import { GET_CURRENT_USER_QUERY_KEY } from '@/hooks/api/users/useGetCurrentUser';
import { getBaseUrl } from '@/services/api';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { AuthService } from '../types';
import { useCompareCart } from '@/services/compareCart/useCompareCart';
import axios from 'axios';

const CN_AUTH_TOKEN_QUERY_KEY = 'cnAuthToken';

const getCurrentAccessToken = (): string | undefined => {
  return localStorage.getItem('authToken') || undefined;
};

const exchangeToken = async (): Promise<string> => {
  const response = await axios.post<{ token: string }>(`${getBaseUrl()}/auth/token`);
  return response.data.token;
};

export const useCnAuth = (): AuthService => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { clearCart } = useCompareCart();

  const { data: token, isLoading } = useQuery({
    queryKey: [CN_AUTH_TOKEN_QUERY_KEY],
    queryFn: async () => {
      const data = await exchangeToken();
      localStorage.setItem('authToken', data);
      return data;
    },
    enabled: !getCurrentAccessToken(),
    retry: 2,
    retryDelay: attempt => (attempt === 0 ? 1000 : 2000),
  });

  const isAuthenticated = !!token || !!getCurrentAccessToken();

  const logout = async () => {
    await queryClient.resetQueries({ queryKey: [GET_CURRENT_USER_QUERY_KEY] });
    localStorage.removeItem('authToken');
    queryClient.setQueryData([CN_AUTH_TOKEN_QUERY_KEY], undefined);
    clearCart();
    navigate('/signin', { state: { loggedOut: true } });
  };

  return {
    authType: 'cn',
    isAuthenticated,
    isLoading,
    logout,
    getCurrentAccessToken,
  };
};
